// extracted by mini-css-extract-plugin
export var dropdownIcon = "_lr-6";
export var imgContainer = "_lr-3";
export var menuIcon = "_lr-5";
export var pillWrapper = "_lr-2";
export var pillsContainer = "_lr-1";
export var subscriptionCard = "_lr-0";
export var subscriptionLogo = "_lr-4";